import { InjectionToken } from "@angular/core";
import { PortalOverriddenLanguageModel } from "../models";

export const PORTAL_PRODUCT_OVERRIDDEN_LANGUAGES = new InjectionToken<PortalOverriddenLanguageModel[]>(
  "PORTAL_PRODUCT_OVERRIDDEN_LANGUAGES"
);
